import {
  CLUB_SIGNUP_REQUEST,
  CREATE_CLUB_SIGNUP_BY_SLUG_REQUEST,
  GET_CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET,
  PROCESS_CLUB_SIGNUP_FULLSTEAM_WALLET_REQUEST,
  GET_VIRTUAL_CART_REQUEST,
  GET_CLUB_SIGNUP_FOR_SHARING_REQUEST,
  EDIT_CLUB_SIGNUP_VIRTUAL_REQUEST,
  PROCESS_CLUB_SIGN_UP_REQUEST,
  PROCESS_PAY_STACK_CLUB_SIGN_UP_REQUEST,
  CREATE_CLUB_SIGNUP_REQUEST,
  CREATE_CUSTOMER_AND_SETUP_INTENT_FOR_STRIPE_REQUEST,
  PROCESS_STRIPE_CLUB_SIGNUP_FROM_PAYMENT_REQUEST,
  MOBILE_CLUB_SIGNUP_SUMMARY_NOT_VISIBLE,
  MOBILE_CLUB_SIGNUP_SUMMARY_VISIBLE,
  UPDATE_CLUB_SIGNUP_FREQUENCY_REQUEST,
  UPDATE_CLUB_SIGNUP_ITEM_SELECTION_REQUEST,
  UPDATE_CLUB_SIGNUP_REQUEST,
  UPDATE_DYNAMIC_PRICING_CLUB_SIGNUP_PACKAGE_REQUEST
} from './constants';

export const authenticateFullSteamWallet = (onSuccess, onError) => ({
  type: GET_CLUB_SIGNUP_AUTH_FULLSTEAM_WALLET,
  onSuccess,
  onError
});

export const processClubSignupForFullSteamWallet = (
  clubSignupId,
  payload,
  onSuccess,
  onError
) => ({
  type: PROCESS_CLUB_SIGNUP_FULLSTEAM_WALLET_REQUEST,
  clubSignupId,
  payload,
  onSuccess,
  onError
});

export const showMobileSummary = () => ({
  type: MOBILE_CLUB_SIGNUP_SUMMARY_VISIBLE
});

export const hideMobileSummary = () => ({
  type: MOBILE_CLUB_SIGNUP_SUMMARY_NOT_VISIBLE
});

export const createClubSignup = (club, onSuccess) => ({
  type: CREATE_CLUB_SIGNUP_REQUEST,
  club,
  onSuccess
});

export const createClubSignupBySlug = (slug, onSuccess) => ({
  type: CREATE_CLUB_SIGNUP_BY_SLUG_REQUEST,
  slug,
  onSuccess
});

export const getClubSignup = () => ({ type: CLUB_SIGNUP_REQUEST });

export const updateDynamicPricingClubSignup = (items) => ({
  type: UPDATE_DYNAMIC_PRICING_CLUB_SIGNUP_PACKAGE_REQUEST,
  items
});

export const getForSharing = (id, onSuccess) => ({
  id,
  type: GET_CLUB_SIGNUP_FOR_SHARING_REQUEST,
  onSuccess
});

export const getVirtualCart = (id, queryParams, onSuccess) => {
  return {
    id,
    queryParams,
    type: GET_VIRTUAL_CART_REQUEST,
    onSuccess
  };
};

export const editVirtualSignUp = (payload, onSuccess) => ({
  type: EDIT_CLUB_SIGNUP_VIRTUAL_REQUEST,
  payload,
  onSuccess
});

export const updateClubSignup = (clubSignup, onSuccess, onError) => ({
  type: UPDATE_CLUB_SIGNUP_REQUEST,
  clubSignup,
  onSuccess,
  onError
});

export const processClubSignup = (payload, onSuccess, onError) => ({
  payload,
  type: PROCESS_CLUB_SIGN_UP_REQUEST,
  onSuccess,
  onError
});

export const createStripeCustomerAndSetupIntent = (
  paymentMethodData,
  onSuccess,
  onError
) => ({
  type: CREATE_CUSTOMER_AND_SETUP_INTENT_FOR_STRIPE_REQUEST,
  paymentMethodData,
  onSuccess,
  onError
});

export const processPaystack = (payload, onSuccess, onError) => ({
  type: PROCESS_PAY_STACK_CLUB_SIGN_UP_REQUEST,
  payload,
  onSuccess,
  onError
});

export const processStripeClubSignupFromPaymentRequest = (
  clubSignupUpdateParams,
  onSuccess,
  onError
) => ({
  type: PROCESS_STRIPE_CLUB_SIGNUP_FROM_PAYMENT_REQUEST,
  clubSignupUpdateParams,
  onSuccess,
  onError
});
export const updateFrequency = (frequency) => ({
  type: UPDATE_CLUB_SIGNUP_FREQUENCY_REQUEST,
  frequency
});

export const updateItemSelection = (itemSelection) => ({
  type: UPDATE_CLUB_SIGNUP_ITEM_SELECTION_REQUEST,
  itemSelection
});
